import { render, staticRenderFns } from "./ProfileSettingsLogoutButton.vue?vue&type=template&id=c19133fe&scoped=true"
import script from "./ProfileSettingsLogoutButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileSettingsLogoutButton.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileSettingsLogoutButton.vue?vue&type=style&index=0&id=c19133fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c19133fe",
  null
  
)

export default component.exports